module.exports = __webpack_public_path__ + "img/0Q3B8222_FoamcoreMatted_MockedUp.1dee5566.jpg";